import { render, staticRenderFns } from "./features-showcase-pending-user-cta.vue?vue&type=template&id=1a12e1c2&scoped=true&"
import script from "./features-showcase-pending-user-cta.vue?vue&type=script&lang=ts&"
export * from "./features-showcase-pending-user-cta.vue?vue&type=script&lang=ts&"
import style0 from "./features-showcase-pending-user-cta.vue?vue&type=style&index=0&id=1a12e1c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a12e1c2",
  null
  
)

export default component.exports